import React from 'react';
import { observer } from 'mobx-react';
import { ListStore } from 'shared/stores/ListStore';
import HiresTable from '../components/HiresTable';
import { JobVacancyStore } from 'ats/pages/job-positions/JobVacancyStore';
import { Pagination } from 'ats/components/pagination/Pagination';
import EmptyState from 'ats/components/empty-state/EmptyState';
import { EMPTY_STATE_ICONS } from 'ats/components/empty-state/emptyStateIcons';

@observer
export class ClientHires extends React.Component {
	constructor(props) {
		super(props);
		this.jobVacancyStore = new JobVacancyStore();
		this.listStore = new ListStore(this.jobVacancyStore, {
			entityName: 'Job Vacancy'
		});
	}

	preConfigureQuery() {
		this.listStore.store.resetQuery();
		this.listStore.store.setQuery('clientId', this.props.client?.id);
		this.listStore.store.setQuery('status', 'filled');
		this.listStore.store.setQuery('sort', {
			column: 'createdAt',
			asc: false
		});
	}

	componentDidMount() {
		this.preConfigureQuery();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.client !== this.props.client) {
			this.preConfigureQuery();
			this.listStore.search();
		}
	}

	handlePaginationChange = (page, limit) => {
		this.listStore.handlePaginationChange(page, limit);
	};

	render() {
		const hasHires = this.listStore.data.length > 0;

		return (
			<div className="client-hires">
				<div className="client-tab-section-header">
					<div className="client-tab-section-title">Hires</div>
				</div>
				<div className="client-hires-body">
					{hasHires ? (
						<>
							<div className="client-hires-container">
								<HiresTable
									data={this.listStore.data}
									sort={this.listStore.store.query.sort}
									onSort={this.listStore.handleSort}
									onSuccess={() => {
										this.listStore.search();
									}}
								/>
							</div>
							<Pagination
								loading={this.listStore.loading}
								pagination={this.listStore.store.query.pagination}
								onPaginationChange={this.handlePaginationChange}
							/>
						</>
					) : (
						<EmptyState
							icon={EMPTY_STATE_ICONS.sheet}
							iconAlt="No hires"
							message="No hires have been assigned yet."
						/>
					)}
				</div>
			</div>
		);
	}
}
